import React from 'react'
import { classNames } from '~/utils/client/helpers'

export type StepsProps = React.ComponentProps<'ol'> & {
  vertical?: boolean
}

export const Steps: React.FC<StepsProps> = ({
  className,
  children,
  vertical = false,
  ...props
}) => {
  const directionStyle = vertical ? 'flex flex-col' : 'flex items-start'
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ol
      role="list"
      className={classNames('overflow-hidden cursor-default', directionStyle, className)}
      {...props}
    >
      {children}
    </ol>
  )
}
